import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import Logo from 'images/integria-logo-dark.png'

export default function NotFound() {
  const history = useHistory()

  useEffect(() => {
    document.documentElement.style.setProperty('--body-bg-color', 'white');
  }, [])

  const handleGoHome = () => {
    history.push('/')
  }

  return (
    <div className="bg-white">
      <Header />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mb-24">
        <div className="text-center py-20">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Page not found
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <button
            onClick={handleGoHome}
            className="bg-integria-green text-white px-6 py-3 rounded-lg font-medium hover:bg-integria-green/90 transition-colors"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  )
}

function Header() {
  return (
    <div className="flex justify-center">
      <img
        src={Logo}
        className="object-center object-contain h-20 mb-20"
        alt="Integria Logo"
      />
    </div>
  )
}